/**
 * List all possible commands the system is capable of processing.
 */
export enum ReservationSkipOffersIfRuleName {
  availability = 'availability',
  channelMax = 'channelMax',
}

export type ReservationSkipOffersIfRuleType = keyof typeof ReservationSkipOffersIfRuleName;
